var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import { getAmountFromToken } from '../../views/AmountSelection/AmountFromToken';
// Default to full switch so we never have to deal with falsey amount selection values
export var initialState = { action: 'full_switch' };
export var amountSelectionSlice = createSlice({
    name: 'amountSelection',
    initialState: initialState,
    reducers: {
        setAmountSelection: function (_, action) { return (__assign({}, action.payload)); },
        setDefaultAmountSelection: function (state, action) {
            var _a = action.payload, linkParams = _a.linkParams, loadedPlatform = _a.loadedPlatform;
            var linkTokenPayload = linkParams.linkTokenPayload;
            var amount = linkTokenPayload.amount, allocation = linkTokenPayload.allocation;
            if (amount === 0 || (allocation === null || allocation === void 0 ? void 0 : allocation.value) === 0) {
                return {
                    action: 'partial_switch',
                    allocation: { type: 'amount', value: 0 },
                };
            }
            if (amount || ((allocation === null || allocation === void 0 ? void 0 : allocation.type) === 'amount' && allocation.value !== 0)) {
                return {
                    action: 'partial_switch',
                    allocation: {
                        type: 'amount',
                        value: getAmountFromToken(linkTokenPayload),
                    },
                };
            }
            if (loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.fullSwitchSupported) {
                if (linkTokenPayload.skipDepositConfirmation) {
                    // Default amount selection is remainder. This is how it worked in Jarvis flow.
                    // We need to keep it this way for Cash.
                    return {
                        action: 'partial_switch',
                        allocation: { type: 'remainder' },
                    };
                }
                return {
                    action: 'full_switch',
                };
            }
            return {
                action: 'partial_switch',
                allocation: { type: 'remainder' },
            };
        },
    },
});
export var setAmountSelection = (_a = amountSelectionSlice.actions, _a.setAmountSelection), setDefaultAmountSelection = _a.setDefaultAmountSelection;
export var selectAmountSelection = function (state) {
    return state.amountSelection;
};
export default amountSelectionSlice.reducer;
